/**
 * @generated SignedSource<<4b14912064bf3b7ed77776159fcb8dda>>
 * @relayHash a6c8e6077212cfff30e6e8d98674323b
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a6c8e6077212cfff30e6e8d98674323b

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Access = "APP" | "BOOK_DOC_AT_PARTNER" | "BOOK_DOC_AT_PHARMACY" | "INBOUND_CALL" | "OUTBOUND_CALL" | "PARTNER_PORTAL" | "WEBSITE" | "WEB_BOOKING";
export type AppointmentStatus = "CANCELLED" | "CLOSED" | "IN_PROGRESS" | "OPEN";
export type AppointmentType = "FLAT_LENGTH_FULL_HOUR" | "FOLLOW_UP" | "LONGER" | "NORMAL";
export type AsyncRequestStatus = "APPROVED" | "REJECTED";
export type BetterDocRejectionReason = "BETTER_DOC_CHOSE_CARE_PROVIDER_BEFOREHAND" | "PATIENT_REFUSES_TO_USE_BETTER_DOC";
export type CallerRole = "DAUGHTER" | "DOMESTIC_PARTNER" | "FATHER" | "GRANDFATHER" | "GRANDMOTHER" | "MOTHER" | "OTHER" | "PATIENT" | "PHARMACY" | "SON";
export type ChMedicationType = "FREE_TEXT_MEDICATION" | "PREPARATION" | "SUBSTANCE" | "TEMPLATE";
export type CommunicationChannel = "ASYNC_REQUEST" | "CHAT" | "PHONE" | "VIDEO";
export type ConclusionStatus = "CONCLUDED" | "FAILED" | "IN_CONCLUSION";
export type DocumentType = "AUDIO" | "PDF" | "PHOTO" | "VIDEO";
export type FileUploadRequestStatus = "CANCELED" | "CLOSED" | "PENDING" | "UPLOADED";
export type FileUploadStatus = "ERROR" | "HYPERLINK_PROCESSING_FAILED" | "JAVA_SCRIPT_PROCESSING_FAILED" | "MALICIOUS" | "NO_THREAT_FOUND" | "SCAN_TIMEOUT" | "UPLOADED";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type MedgateConnectChannel = "PARTNER" | "PATIENT";
export type MedgateConnectOrderStatus = "CLOSED" | "FULFILLED" | "OPEN";
export type MedicalPrescription = "DIAGNOSTIC_NEUROPSYCHOLOGY_FOR_SUSPECTED_BRAIN_DISORDERS" | "PROGRESS_ASSESSMENT";
export type MedicalReportType = "MEDICAL_REPORT" | "OTHER";
export type MedicationUnit = "GTT" | "IU" | "MG" | "ML" | "PC" | "PRN" | "PUFF";
export type PartnerType = "MEAS" | "PHARMACY" | "SPITEX";
export type PointOfCareType = "EMERGENCY_CALL" | "EXTERNAL_ASSISTANCE" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE" | "HOSPITAL_EMERGENCY_ROOM" | "INCOMPLETE_TELECONSULTATION" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "SPECIALIST" | "TELECARE";
export type ProgressNoteKind = "ADMINISTRATIVE" | "MEDICAL";
export type ReasonForChoosingType = "INFRASTRUCTURE" | "PATIENT_REQUEST" | "TIME";
export type RequestExamination = "CHEST_X_RAY_TWO_PLANES" | "CLAVICLE_AP_TANGENTIAL" | "ELLBOW_AP_LAT" | "FOOT_AP_OBLIQUE" | "FOOT_LAT" | "HAND_AP_OBLIQUE" | "HAND_LAT" | "HIPJOINT_AXIAL" | "KNEE_AP_LAT" | "LOWERARM_AP_LAT" | "LOWER_LEG_JOINT" | "PATELLA_AXIAL" | "PELVIS_AP" | "PELVIS_STANDARD" | "SHOULDER_AP_NEER" | "TOE_AP_OBLIQUE" | "UAJ_AP_LAT" | "UPPERARM_AP_LAT" | "UPPER_LEG_JOINT" | "WRIST_AP_LAT";
export type RequestType = "NONE" | "ONBOARDING_CALL" | "PLANNED_SELF_REFERRAL" | "PRESCRIPTION" | "PRESCRIPTION_ASTHMA" | "PRESCRIPTION_ATHLETES_FOOT" | "PRESCRIPTION_BLOOD_PRESSURE" | "PRESCRIPTION_CONTRACEPTIVE_PILL" | "PRESCRIPTION_ERECTILE_DYSFUNCTION" | "PRESCRIPTION_HAY_FEVER" | "PRESCRIPTION_HEARTBURN" | "PRESCRIPTION_HYPOTHYROIDISM" | "PRESCRIPTION_MIGRAINE" | "PRESCRIPTION_URINARY_TRACT_INFECTION" | "PRESCRIPTION_VAGINAL_MYCOSIS" | "REFERRAL" | "SICK_LEAVE_CERTIFICATE" | "SICK_LEAVE_FOR_LEGAL_GUARDIAN" | "SKIN_CHECK";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
export type ServiceSpecialty = "CARDIOLOGY" | "DERMATOLOGY" | "GYNAECOLOGY" | "LONG_COVID" | "NONE" | "OTORHINOLARYNGOLOGY" | "PEDIATRICS" | "UROLOGY" | "VACCINATION_AND_TRAVEL_ADVICE";
export type TimeToTreatType = "LATER" | "URGENT" | "WITHIN12H" | "WITHIN14DAYS" | "WITHIN24H" | "WITHIN48H" | "WITHIN6H";
export type Ch_updateProgressNoteEpisodeOfCareInput = {
  episodeOfCareId: string;
  id: string;
};
export type chUpdateProgressNoteEpisodeOfCareMutation$variables = {
  addConnections: ReadonlyArray<string>;
  input: Ch_updateProgressNoteEpisodeOfCareInput;
  removedConnections: ReadonlyArray<string>;
};
export type chUpdateProgressNoteEpisodeOfCareMutation$data = {
  readonly updateProgressNoteEpisodeOfCare: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly updateProgressNoteEpisodeOfCareOutput: {
      readonly currentEpisodeOfCare: {
        readonly id: string;
        readonly updatedAt: string;
      } | null;
      readonly oldEpisodeOfCare: {
        readonly id: string;
        readonly updatedAt: string;
      } | null;
      readonly progressNote: {
        readonly __typename: "ch_ProgressNote";
        readonly anamnesis: string | null;
        readonly appointment: {
          readonly access: Access;
          readonly appointmentAttachments: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"AppointmentAttachmentFragment">;
          }>;
          readonly appointmentType: AppointmentType;
          readonly asyncRequestStatus: AsyncRequestStatus | null;
          readonly billingAttribute: {
            readonly " $fragmentSpreads": FragmentRefs<"BillingAttributeFragment">;
          } | null;
          readonly callerRole: CallerRole | null;
          readonly canUseDoc2U: boolean;
          readonly channel: CommunicationChannel;
          readonly completedAt: string | null;
          readonly conclusionStatus: ConclusionStatus | null;
          readonly createdAt: string;
          readonly hasChatTranscript: boolean;
          readonly healthOverview: {
            readonly generalHealthInformation: {
              readonly " $fragmentSpreads": FragmentRefs<"GeneralHealthInformationFragment">;
            } | null;
            readonly vitalSign: {
              readonly " $fragmentSpreads": FragmentRefs<"VitalSignFragment">;
            } | null;
          } | null;
          readonly id: string;
          readonly isCompleted: boolean;
          readonly isInvoiced: boolean;
          readonly isPartnerInVideoCall: boolean;
          readonly language: Language;
          readonly medgateConnectChannel: MedgateConnectChannel | null;
          readonly partnerType: PartnerType | null;
          readonly partnerUserEmail: string | null;
          readonly patientAddress: {
            readonly city: string;
            readonly countryCode: string;
            readonly houseNumberStreet: string;
            readonly postalCode: string;
          } | null;
          readonly patientPhoneNumber: string | null;
          readonly questionnaireCriticalitySummary: {
            readonly " $fragmentSpreads": FragmentRefs<"QuestionnaireCriticalitySummaryFragment">;
          } | null;
          readonly questionnaireId: number | null;
          readonly reason: string;
          readonly requestType: RequestType;
          readonly service: Service;
          readonly specialty: ServiceSpecialty;
          readonly status: AppointmentStatus;
          readonly suggestedQuestionnaireDiagnosisCodes: ReadonlyArray<{
            readonly diagnosisCode: string;
            readonly id: string;
            readonly text: string;
          }>;
          readonly telephoneLine: {
            readonly telephoneLineTranslations: ReadonlyArray<{
              readonly content: string;
              readonly language: Language;
            }>;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"RequestedMedicationsFragment">;
        };
        readonly attestationGuardian: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly durationFrom: any;
          readonly durationTo: any;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly id: string;
          readonly progressNoteId: string;
          readonly sentAt: string | null;
          readonly sentBy: string | null;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"chLegalGuardianAttestationFragment">;
        } | null;
        readonly betterDoc: {
          readonly isUsed: boolean | null;
          readonly rejectionReason: BetterDocRejectionReason | null;
        } | null;
        readonly carePlanSummary: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly concludedAt: string | null;
              readonly concludedBy: string | null;
              readonly createdAt: string;
              readonly createdBy: string;
              readonly fileId: string | null;
              readonly fileMetadata: {
                readonly documentType: string;
                readonly extension: string;
                readonly lengthInKilobytes: number;
              } | null;
              readonly id: string;
              readonly progressNoteId: string;
              readonly signedAt: string | null;
              readonly signedBy: string | null;
              readonly treatmentPlan: {
                readonly followUpTreatment: string;
                readonly from: any;
                readonly recommendedTreatment: string;
                readonly title: string;
                readonly to: any;
              };
              readonly updatedAt: string | null;
              readonly updatedBy: string | null;
            };
          }> | null;
        } | null;
        readonly ch_callTranscripts: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly callTranscriptEndedAt: string;
              readonly id: string;
              readonly transcript: ReadonlyArray<{
                readonly id: string;
                readonly text: string;
              }>;
            };
          }> | null;
        } | null;
        readonly ch_consultationReport: {
          readonly anamnesis: string;
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly diagnosisCode: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly healthcareProviderId: string;
          readonly id: string;
          readonly language: Language;
          readonly progressNoteId: string;
          readonly recommendedTreatment: string;
          readonly sentAt: string | null;
          readonly sentBy: string | null;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"consultationReportFragment">;
        } | null;
        readonly ch_laboratoryPrescription: {
          readonly additionalRemark: string | null;
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly externalExaminations: ReadonlyArray<string>;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly id: string;
          readonly isDoc2u: boolean;
          readonly language: Language;
          readonly patientId: string;
          readonly pointOfCareExaminations: ReadonlyArray<string>;
          readonly progressNoteId: string;
          readonly sentAt: string | null;
          readonly sentBy: string | null;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"chLaboratoryPrescriptionDrawerFragment">;
        } | null;
        readonly ch_measRadiologyPrescription: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly id: string;
          readonly progressNoteId: string;
          readonly requestExaminations: ReadonlyArray<RequestExamination>;
          readonly sentAt: string | null;
          readonly sentBy: string | null;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"chMeasRadiologyPrescriptionFragment">;
        } | null;
        readonly ch_neuropsychologicDiagnosticPrescription: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly email: string | null;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly healthcareProviderId: string | null;
          readonly id: string;
          readonly language: Language;
          readonly medicalPrescriptions: ReadonlyArray<MedicalPrescription>;
          readonly name: string | null;
          readonly patientId: string;
          readonly phoneNumber: string | null;
          readonly progressNoteId: string;
          readonly relationship: string | null;
          readonly sentAt: string | null;
          readonly sentBy: string | null;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"chNeuropsychologicDiagnosticPrescriptionDrawerFragment">;
        } | null;
        readonly ch_nutritionalPrescription: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly diagnosisCode: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly healthcareProviderId: string | null;
          readonly id: string;
          readonly language: Language;
          readonly medicationIds: ReadonlyArray<string> | null;
          readonly progressNoteId: string;
          readonly sentAt: string | null;
          readonly sentBy: string | null;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"chNutritionalCounsellingFragment">;
        } | null;
        readonly ch_recommendedMedications: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
              readonly medication: {
                readonly __typename: "ch_Medication";
                readonly createdAt: string;
                readonly createdBy: string;
                readonly endDate: any | null;
                readonly eveningDosage: number;
                readonly id: string;
                readonly internalNotes: string | null;
                readonly isPermanentPrescription: boolean;
                readonly morningDosage: number;
                readonly name: string;
                readonly nightDosage: number;
                readonly noonDosage: number;
                readonly numberOfPackages: number;
                readonly packageSize: string | null;
                readonly patientId: string;
                readonly pharmaCode: number | null;
                readonly productUrl: any | null;
                readonly refuseSubstitutes: boolean;
                readonly startDate: any | null;
                readonly templateCategory: string | null;
                readonly templateId: number | null;
                readonly type: ChMedicationType;
                readonly unit: MedicationUnit;
                readonly updatedAt: string | null;
                readonly updatedBy: string | null;
                readonly usageInstructions: string | null;
              };
              readonly medicationId: number;
              readonly patientId: string;
              readonly progressNoteId: number;
            };
          }> | null;
        } | null;
        readonly createdAt: string;
        readonly createdBy: string;
        readonly episodeOfCareId: string | null;
        readonly followUpAppointment: {
          readonly assignedTo: string | null;
          readonly completedAt: string | null;
          readonly date: any;
          readonly fileUploadRequest: {
            readonly createdAt: string;
            readonly sessionCode: string;
            readonly status: FileUploadRequestStatus;
          } | null;
          readonly id: string;
          readonly initialAssignedToUser: {
            readonly firstName: string;
            readonly id: string;
            readonly lastName: string;
          } | null;
          readonly initialBookedDateTime: string;
          readonly medgateConnectOrder: {
            readonly createdAt: string;
            readonly orderCode: string;
            readonly status: MedgateConnectOrderStatus;
          } | null;
          readonly partnerType: PartnerType | null;
          readonly rescheduledAt: string | null;
          readonly rescheduledBy: string | null;
          readonly rescheduledByUser: {
            readonly firstName: string;
            readonly id: string;
            readonly lastName: string;
          } | null;
          readonly service: Service;
          readonly slotId: number;
          readonly status: AppointmentStatus;
          readonly takenBy: string | null;
        } | null;
        readonly generalAttestation: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly id: string;
          readonly name: string;
          readonly progressNoteId: string;
          readonly sentAt: string | null;
          readonly sentBy: string | null;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly subject: string;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"chGeneralAttestationsFragment">;
        } | null;
        readonly id: string;
        readonly kind: ProgressNoteKind;
        readonly measLaboratoryPrescription: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly id: string;
          readonly progressNoteId: string;
          readonly sentAt: string | null;
          readonly sentBy: string | null;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"chMeasLaboratoryPrescriptionFragment">;
        } | null;
        readonly medicalReportAttachments: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly attachmentType: DocumentType;
              readonly createdAt: string;
              readonly fileName: string;
              readonly id: string;
              readonly progressNoteId: string;
              readonly reportType: MedicalReportType;
              readonly sessionId: string;
              readonly uploadStatus: FileUploadStatus | null;
              readonly url: string;
            };
          }> | null;
        } | null;
        readonly physiotherapy: {
          readonly allergies: ReadonlyArray<string> | null;
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly conditions: ReadonlyArray<string> | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly diagnosisCode: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly healthcareProviderId: string | null;
          readonly id: string;
          readonly progressNoteId: string;
          readonly sentAt: string | null;
          readonly sentBy: string | null;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly treatmentUnit: number;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"chPhysiotherapyFragment">;
        } | null;
        readonly pointOfCare: {
          readonly __typename: "ch_PointOfCare";
          readonly actual: PointOfCareType | null;
          readonly careProvider: {
            readonly businessName: string | null;
            readonly city: string | null;
            readonly countryCode: string | null;
            readonly firstName: string | null;
            readonly id: string;
            readonly lastName: string | null;
            readonly phoneNumber: string | null;
            readonly postalCode: string | null;
            readonly streetAddress: string | null;
            readonly title: string | null;
          } | null;
          readonly careProviderId: number | null;
          readonly careProviderSpecialty: {
            readonly id: string;
            readonly name: string;
            readonly specialtyTranslations: ReadonlyArray<{
              readonly id: string;
              readonly language: string;
              readonly name: string;
              readonly specialtyId: number;
            }>;
          } | null;
          readonly isDoctorVisitAvoided: boolean | null;
          readonly medical: PointOfCareType;
          readonly pointOfCareSpecialty: {
            readonly careProviderSpecialty: {
              readonly id: string;
              readonly name: string;
            } | null;
            readonly id: string;
            readonly specialtyTranslations: ReadonlyArray<{
              readonly language: string;
              readonly name: string;
            }>;
            readonly synonym: string | null;
            readonly word: string;
          } | null;
          readonly purpose: {
            readonly instrumentalExamination: boolean | null;
            readonly laboratory: boolean | null;
            readonly physicalExam: boolean | null;
          } | null;
          readonly reasonForChoosingActual: ReasonForChoosingType | null;
          readonly specialtyId: number | null;
          readonly timeToTreatType: TimeToTreatType | null;
        } | null;
        readonly prescription: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly healthcareProviderId: string | null;
          readonly id: string;
          readonly medications: ReadonlyArray<{
            readonly eveningDosage: number;
            readonly id: string;
            readonly morningDosage: number;
            readonly name: string;
            readonly nightDosage: number;
            readonly noonDosage: number;
            readonly unit: MedicationUnit;
          }>;
          readonly progressNoteId: string;
          readonly sentAt: string | null;
          readonly sentBy: string | null;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"chPrescriptionFragment">;
        } | null;
        readonly progressNoteId: number;
        readonly psychologicalPsychotherapy: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly diagnosisCode: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly healthcareProviderId: string | null;
          readonly id: string;
          readonly progressNoteId: string;
          readonly sentAt: string | null;
          readonly sentBy: string | null;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"chPsychologicalPsychoTherapyFragment">;
        } | null;
        readonly referralLetter: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly id: string;
          readonly progressNoteId: string;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"chReferralLetterFragment">;
        } | null;
        readonly sickLeave: {
          readonly concludedAt: string | null;
          readonly concludedBy: string | null;
          readonly createdAt: string;
          readonly createdBy: string;
          readonly employerName: string;
          readonly fileId: string | null;
          readonly fileMetadata: {
            readonly documentType: string;
            readonly extension: string;
            readonly lengthInKilobytes: number;
          } | null;
          readonly from: any;
          readonly id: string;
          readonly progressNoteId: string;
          readonly sentAt: string | null;
          readonly sentBy: string | null;
          readonly signedAt: string | null;
          readonly signedBy: string | null;
          readonly to: any;
          readonly updatedAt: string | null;
          readonly updatedBy: string | null;
          readonly " $fragmentSpreads": FragmentRefs<"chSickLeaveFragment">;
        } | null;
        readonly timeWindows: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly id: string;
            };
          }> | null;
        } | null;
        readonly treatmentPlan: {
          readonly followUpInstructions: string | null;
          readonly from: any;
          readonly recommended: string | null;
          readonly title: string;
          readonly to: any;
        } | null;
        readonly updatedAt: string;
        readonly updatedBy: string;
        readonly " $fragmentSpreads": FragmentRefs<"chProgressNoteFragment">;
      };
    } | null;
  };
};
export type chUpdateProgressNoteEpisodeOfCareMutation = {
  response: chUpdateProgressNoteEpisodeOfCareMutation$data;
  variables: chUpdateProgressNoteEpisodeOfCareMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "addConnections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "removedConnections"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*:: as any*/)
  ],
  "type": "Error",
  "abstractKey": "__isError"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "progressNoteId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "episodeOfCareId",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "access",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appointmentType",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conclusionStatus",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "asyncRequestStatus",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "specialty",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "service",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientPhoneNumber",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "reason",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCompleted",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInvoiced",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPartnerInVideoCall",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "questionnaireId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "channel",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "callerRole",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedAt",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasChatTranscript",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canUseDoc2U",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "content",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "city",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "countryCode",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postalCode",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "patientAddress",
  "plural": false,
  "selections": [
    (v32/*:: as any*/),
    (v33/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "houseNumberStreet",
      "storageKey": null
    },
    (v34/*:: as any*/)
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestType",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "diagnosisCode",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "IcdDiagnosis",
  "kind": "LinkedField",
  "name": "suggestedQuestionnaireDiagnosisCodes",
  "plural": true,
  "selections": [
    (v37/*:: as any*/),
    (v6/*:: as any*/),
    (v38/*:: as any*/)
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partnerUserEmail",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "medgateConnectChannel",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "partnerType",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slotId",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assignedTo",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "initialBookedDateTime",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v49 = [
  (v6/*:: as any*/),
  (v47/*:: as any*/),
  (v48/*:: as any*/)
],
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "MedgateEmployee",
  "kind": "LinkedField",
  "name": "initialAssignedToUser",
  "plural": false,
  "selections": (v49/*:: as any*/),
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rescheduledBy",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rescheduledAt",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "MedgateEmployee",
  "kind": "LinkedField",
  "name": "rescheduledByUser",
  "plural": false,
  "selections": (v49/*:: as any*/),
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "takenBy",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sessionCode",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "orderCode",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdBy",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedBy",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "updatedAt",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_ProgressNoteBetterDoc",
  "kind": "LinkedField",
  "name": "betterDoc",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isUsed",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rejectionReason",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "specialtyId",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_PointOfCare",
  "kind": "LinkedField",
  "name": "pointOfCare",
  "plural": false,
  "selections": [
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "medical",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actual",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "reasonForChoosingActual",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDoctorVisitAvoided",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "careProviderId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Purpose",
      "kind": "LinkedField",
      "name": "purpose",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "physicalExam",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "laboratory",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "instrumentalExamination",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v61/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Specialty",
      "kind": "LinkedField",
      "name": "careProviderSpecialty",
      "plural": false,
      "selections": [
        (v6/*:: as any*/),
        (v62/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "SpecialtyTranslation",
          "kind": "LinkedField",
          "name": "specialtyTranslations",
          "plural": true,
          "selections": [
            (v6/*:: as any*/),
            (v27/*:: as any*/),
            (v62/*:: as any*/),
            (v61/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PointOfCareSpecialty",
      "kind": "LinkedField",
      "name": "pointOfCareSpecialty",
      "plural": false,
      "selections": [
        (v6/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "word",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "synonym",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PointOfCareSpecialtyTranslation",
          "kind": "LinkedField",
          "name": "specialtyTranslations",
          "plural": true,
          "selections": [
            (v27/*:: as any*/),
            (v62/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Specialty",
          "kind": "LinkedField",
          "name": "careProviderSpecialty",
          "plural": false,
          "selections": [
            (v6/*:: as any*/),
            (v62/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeToTreatType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CareProvider",
      "kind": "LinkedField",
      "name": "careProvider",
      "plural": false,
      "selections": [
        (v6/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "businessName",
          "storageKey": null
        },
        (v63/*:: as any*/),
        (v47/*:: as any*/),
        (v48/*:: as any*/),
        (v64/*:: as any*/),
        (v33/*:: as any*/),
        (v32/*:: as any*/),
        (v34/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "streetAddress",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "from",
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "to",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "TreatmentPlan",
  "kind": "LinkedField",
  "name": "treatmentPlan",
  "plural": false,
  "selections": [
    (v63/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "followUpInstructions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recommended",
      "storageKey": null
    },
    (v66/*:: as any*/),
    (v67/*:: as any*/)
  ],
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anamnesis",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileId",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "employerName",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedBy",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedAt",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentAt",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sentBy",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "concludedAt",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "concludedBy",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "concreteType": "DocumentFileMetadata",
  "kind": "LinkedField",
  "name": "fileMetadata",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "documentType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "extension",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lengthInKilobytes",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subject",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationFrom",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationTo",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "healthcareProviderId",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "conditions",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "allergies",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "treatmentUnit",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "medicationIds",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "morningDosage",
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "noonDosage",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "eveningDosage",
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nightDosage",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_Medication",
  "kind": "LinkedField",
  "name": "medications",
  "plural": true,
  "selections": [
    (v6/*:: as any*/),
    (v62/*:: as any*/),
    (v87/*:: as any*/),
    (v88/*:: as any*/),
    (v89/*:: as any*/),
    (v90/*:: as any*/),
    (v91/*:: as any*/)
  ],
  "storageKey": null
},
v93 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "recommendedTreatment",
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v96 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Ch_carePlanSummaryEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CarePlanSummary",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CarePlanTreatmentPlan",
            "kind": "LinkedField",
            "name": "treatmentPlan",
            "plural": false,
            "selections": [
              (v63/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "followUpTreatment",
                "storageKey": null
              },
              (v93/*:: as any*/),
              (v66/*:: as any*/),
              (v67/*:: as any*/)
            ],
            "storageKey": null
          },
          (v70/*:: as any*/),
          (v8/*:: as any*/),
          (v72/*:: as any*/),
          (v73/*:: as any*/),
          (v59/*:: as any*/),
          (v18/*:: as any*/),
          (v58/*:: as any*/),
          (v57/*:: as any*/),
          (v76/*:: as any*/),
          (v77/*:: as any*/),
          (v78/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      (v94/*:: as any*/)
    ],
    "storageKey": null
  },
  (v95/*:: as any*/)
],
v97 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Ch_timeWindowsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ch_TimeWindow",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      (v94/*:: as any*/)
    ],
    "storageKey": null
  },
  (v95/*:: as any*/)
],
v98 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "requestExaminations",
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "patientId",
  "storageKey": null
},
v100 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "medicalPrescriptions",
  "storageKey": null
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "relationship",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalExaminations",
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pointOfCareExaminations",
  "storageKey": null
},
v105 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDoc2u",
  "storageKey": null
},
v106 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "additionalRemark",
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v108 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attachmentType",
  "storageKey": null
},
v109 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fileName",
  "storageKey": null
},
v110 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadStatus",
  "storageKey": null
},
v111 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MedicalReportAttachmentEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MedicalReportAttachment",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          (v107/*:: as any*/),
          (v18/*:: as any*/),
          (v108/*:: as any*/),
          (v109/*:: as any*/),
          (v110/*:: as any*/),
          (v8/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "reportType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sessionId",
            "storageKey": null
          },
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      (v94/*:: as any*/)
    ],
    "storageKey": null
  },
  (v95/*:: as any*/)
],
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pharmaCode",
  "storageKey": null
},
v113 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productUrl",
  "storageKey": null
},
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "packageSize",
  "storageKey": null
},
v115 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Ch_recommendedMedicationsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ch_RecommendedMedication",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*:: as any*/),
          (v99/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "medicationId",
            "storageKey": null
          },
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ch_Medication",
            "kind": "LinkedField",
            "name": "medication",
            "plural": false,
            "selections": [
              (v7/*:: as any*/),
              (v6/*:: as any*/),
              (v62/*:: as any*/),
              (v99/*:: as any*/),
              (v112/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              (v91/*:: as any*/),
              (v87/*:: as any*/),
              (v88/*:: as any*/),
              (v89/*:: as any*/),
              (v90/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "usageInstructions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "internalNotes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "templateCategory",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v113/*:: as any*/),
              (v114/*:: as any*/),
              (v59/*:: as any*/),
              (v58/*:: as any*/),
              (v18/*:: as any*/),
              (v57/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "refuseSubstitutes",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfPackages",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isPermanentPrescription",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      (v94/*:: as any*/)
    ],
    "storageKey": null
  },
  (v95/*:: as any*/)
],
v116 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Ch_callTranscriptsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CallTranscript",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v6/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "TranscriptEntry",
            "kind": "LinkedField",
            "name": "transcript",
            "plural": true,
            "selections": [
              (v6/*:: as any*/),
              (v38/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "callTranscriptEndedAt",
            "storageKey": null
          },
          (v7/*:: as any*/)
        ],
        "storageKey": null
      },
      (v94/*:: as any*/)
    ],
    "storageKey": null
  },
  (v95/*:: as any*/)
],
v117 = [
  (v6/*:: as any*/),
  (v59/*:: as any*/)
],
v118 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_EpisodeOfCare",
  "kind": "LinkedField",
  "name": "currentEpisodeOfCare",
  "plural": false,
  "selections": (v117/*:: as any*/),
  "storageKey": null
},
v119 = {
  "alias": null,
  "args": null,
  "concreteType": "ch_EpisodeOfCare",
  "kind": "LinkedField",
  "name": "oldEpisodeOfCare",
  "plural": false,
  "selections": (v117/*:: as any*/),
  "storageKey": null
},
v120 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "additionalInformation",
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "employer",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chUpdateProgressNoteEpisodeOfCareMutation",
    "selections": [
      {
        "alias": "updateProgressNoteEpisodeOfCare",
        "args": (v3/*:: as any*/),
        "concreteType": "Ch_updateProgressNoteEpisodeOfCarePayload",
        "kind": "LinkedField",
        "name": "ch_updateProgressNoteEpisodeOfCare",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "updateProgressNoteEpisodeOfCareOutput",
            "args": null,
            "concreteType": "ch_UpdateProgressNoteEpisodeOfCareOutput",
            "kind": "LinkedField",
            "name": "ch_UpdateProgressNoteEpisodeOfCareOutput",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_ProgressNote",
                "kind": "LinkedField",
                "name": "progressNote",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  (v7/*:: as any*/),
                  (v6/*:: as any*/),
                  (v8/*:: as any*/),
                  (v9/*:: as any*/),
                  (v10/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Appointment",
                    "kind": "LinkedField",
                    "name": "appointment",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v11/*:: as any*/),
                      (v12/*:: as any*/),
                      (v13/*:: as any*/),
                      (v14/*:: as any*/),
                      (v15/*:: as any*/),
                      (v16/*:: as any*/),
                      (v17/*:: as any*/),
                      (v18/*:: as any*/),
                      (v19/*:: as any*/),
                      (v20/*:: as any*/),
                      (v21/*:: as any*/),
                      (v22/*:: as any*/),
                      (v23/*:: as any*/),
                      (v24/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QuestionnaireCriticalitySummaryOutput",
                        "kind": "LinkedField",
                        "name": "questionnaireCriticalitySummary",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "QuestionnaireCriticalitySummaryFragment"
                          }
                        ],
                        "storageKey": null
                      },
                      (v25/*:: as any*/),
                      (v26/*:: as any*/),
                      (v27/*:: as any*/),
                      (v28/*:: as any*/),
                      (v29/*:: as any*/),
                      (v30/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ch_TelephoneLine",
                        "kind": "LinkedField",
                        "name": "telephoneLine",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ch_TelephoneLineTranslation",
                            "kind": "LinkedField",
                            "name": "telephoneLineTranslations",
                            "plural": true,
                            "selections": [
                              (v27/*:: as any*/),
                              (v31/*:: as any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AppointmentAttachment",
                        "kind": "LinkedField",
                        "name": "appointmentAttachments",
                        "plural": true,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "AppointmentAttachmentFragment"
                          }
                        ],
                        "storageKey": null
                      },
                      (v35/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BillingAttribute",
                        "kind": "LinkedField",
                        "name": "billingAttribute",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "BillingAttributeFragment"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HealthOverview",
                        "kind": "LinkedField",
                        "name": "healthOverview",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VitalSign",
                            "kind": "LinkedField",
                            "name": "vitalSign",
                            "plural": false,
                            "selections": [
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "VitalSignFragment"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GeneralHealthInformation",
                            "kind": "LinkedField",
                            "name": "generalHealthInformation",
                            "plural": false,
                            "selections": [
                              {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "GeneralHealthInformationFragment"
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "RequestedMedicationsFragment"
                      },
                      (v36/*:: as any*/),
                      (v39/*:: as any*/),
                      (v40/*:: as any*/),
                      (v41/*:: as any*/),
                      (v42/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Appointment",
                    "kind": "LinkedField",
                    "name": "followUpAppointment",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v43/*:: as any*/),
                      (v44/*:: as any*/),
                      (v45/*:: as any*/),
                      (v16/*:: as any*/),
                      (v20/*:: as any*/),
                      (v46/*:: as any*/),
                      (v50/*:: as any*/),
                      (v51/*:: as any*/),
                      (v52/*:: as any*/),
                      (v53/*:: as any*/),
                      (v54/*:: as any*/),
                      (v28/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FileUploadRequest",
                        "kind": "LinkedField",
                        "name": "fileUploadRequest",
                        "plural": false,
                        "selections": [
                          (v20/*:: as any*/),
                          (v55/*:: as any*/),
                          (v18/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MedgateConnectOrder",
                        "kind": "LinkedField",
                        "name": "medgateConnectOrder",
                        "plural": false,
                        "selections": [
                          (v56/*:: as any*/),
                          (v20/*:: as any*/),
                          (v18/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v42/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v57/*:: as any*/),
                  (v58/*:: as any*/),
                  (v59/*:: as any*/),
                  (v18/*:: as any*/),
                  (v60/*:: as any*/),
                  (v65/*:: as any*/),
                  (v68/*:: as any*/),
                  (v69/*:: as any*/),
                  {
                    "alias": "sickLeave",
                    "args": null,
                    "concreteType": "ch_SickLeave",
                    "kind": "LinkedField",
                    "name": "ch_sickLeave",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v71/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v66/*:: as any*/),
                      (v67/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chSickLeaveFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "generalAttestation",
                    "args": null,
                    "concreteType": "ch_GeneralAttestation",
                    "kind": "LinkedField",
                    "name": "ch_generalAttestation",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v73/*:: as any*/),
                      (v72/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v62/*:: as any*/),
                      (v79/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chGeneralAttestationsFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "attestationGuardian",
                    "args": null,
                    "concreteType": "ch_AttestationGuardian",
                    "kind": "LinkedField",
                    "name": "ch_attestationGuardian",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v80/*:: as any*/),
                      (v81/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chLegalGuardianAttestationFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "psychologicalPsychotherapy",
                    "args": null,
                    "concreteType": "ch_PsychotherapyPrescription",
                    "kind": "LinkedField",
                    "name": "ch_psychotherapyPrescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v82/*:: as any*/),
                      (v37/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chPsychologicalPsychoTherapyFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "physiotherapy",
                    "args": null,
                    "concreteType": "ch_PhysiotherapyPrescription",
                    "kind": "LinkedField",
                    "name": "ch_physiotherapyPrescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v82/*:: as any*/),
                      (v37/*:: as any*/),
                      (v83/*:: as any*/),
                      (v84/*:: as any*/),
                      (v85/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chPhysiotherapyFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_NutritionalPrescription",
                    "kind": "LinkedField",
                    "name": "ch_nutritionalPrescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v8/*:: as any*/),
                      (v82/*:: as any*/),
                      (v37/*:: as any*/),
                      (v86/*:: as any*/),
                      (v27/*:: as any*/),
                      (v70/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chNutritionalCounsellingFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "prescription",
                    "args": null,
                    "concreteType": "ch_Prescription",
                    "kind": "LinkedField",
                    "name": "ch_prescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v82/*:: as any*/),
                      (v92/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chPrescriptionFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "measLaboratoryPrescription",
                    "args": null,
                    "concreteType": "ch_MeasLaboratoryPrescription",
                    "kind": "LinkedField",
                    "name": "ch_measLaboratoryPrescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chMeasLaboratoryPrescriptionFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "referralLetter",
                    "args": null,
                    "concreteType": "ch_ReferralLetter",
                    "kind": "LinkedField",
                    "name": "ch_referralLetter",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chReferralLetterFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_ConsultationReport",
                    "kind": "LinkedField",
                    "name": "ch_consultationReport",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v27/*:: as any*/),
                      (v82/*:: as any*/),
                      (v37/*:: as any*/),
                      (v69/*:: as any*/),
                      (v93/*:: as any*/),
                      (v78/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "consultationReportFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "carePlanSummary",
                    "args": null,
                    "concreteType": "Ch_carePlanSummaryConnection",
                    "kind": "LinkedField",
                    "name": "__ProgressNoteConnection_carePlanSummary_connection",
                    "plural": false,
                    "selections": (v96/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "timeWindows",
                    "args": null,
                    "concreteType": "Ch_timeWindowsConnection",
                    "kind": "LinkedField",
                    "name": "__ChProgressNoteConnection_ch_timeWindows_connection",
                    "plural": false,
                    "selections": (v97/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_MeasRadiologyPrescription",
                    "kind": "LinkedField",
                    "name": "ch_measRadiologyPrescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v98/*:: as any*/),
                      (v78/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chMeasRadiologyPrescriptionFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_NeuropsychologicDiagnosticPrescription",
                    "kind": "LinkedField",
                    "name": "ch_neuropsychologicDiagnosticPrescription",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chNeuropsychologicDiagnosticPrescriptionDrawerFragment"
                      },
                      (v6/*:: as any*/),
                      (v99/*:: as any*/),
                      (v8/*:: as any*/),
                      (v18/*:: as any*/),
                      (v57/*:: as any*/),
                      (v73/*:: as any*/),
                      (v72/*:: as any*/),
                      (v27/*:: as any*/),
                      (v59/*:: as any*/),
                      (v58/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v70/*:: as any*/),
                      (v78/*:: as any*/),
                      (v100/*:: as any*/),
                      (v101/*:: as any*/),
                      (v62/*:: as any*/),
                      (v64/*:: as any*/),
                      (v102/*:: as any*/),
                      (v82/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_LaboratoryPrescription",
                    "kind": "LinkedField",
                    "name": "ch_laboratoryPrescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v99/*:: as any*/),
                      (v8/*:: as any*/),
                      (v18/*:: as any*/),
                      (v57/*:: as any*/),
                      (v73/*:: as any*/),
                      (v72/*:: as any*/),
                      (v27/*:: as any*/),
                      (v103/*:: as any*/),
                      (v104/*:: as any*/),
                      (v105/*:: as any*/),
                      (v106/*:: as any*/),
                      (v59/*:: as any*/),
                      (v58/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v70/*:: as any*/),
                      (v78/*:: as any*/),
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "chLaboratoryPrescriptionDrawerFragment"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "medicalReportAttachments",
                    "args": null,
                    "concreteType": "MedicalReportAttachmentConnection",
                    "kind": "LinkedField",
                    "name": "__ProgressNoteConnection_medicalReportAttachments_connection",
                    "plural": false,
                    "selections": (v111/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "ch_recommendedMedications",
                    "args": null,
                    "concreteType": "Ch_recommendedMedicationsConnection",
                    "kind": "LinkedField",
                    "name": "__ProgressNoteConnection_ch_recommendedMedications_connection",
                    "plural": false,
                    "selections": (v115/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "ch_callTranscripts",
                    "args": null,
                    "concreteType": "Ch_callTranscriptsConnection",
                    "kind": "LinkedField",
                    "name": "__ProgressNoteConnection_ch_callTranscripts_connection",
                    "plural": false,
                    "selections": (v116/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "chProgressNoteFragment"
                  }
                ],
                "storageKey": null
              },
              (v118/*:: as any*/),
              (v119/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chUpdateProgressNoteEpisodeOfCareMutation",
    "selections": [
      {
        "alias": "updateProgressNoteEpisodeOfCare",
        "args": (v3/*:: as any*/),
        "concreteType": "Ch_updateProgressNoteEpisodeOfCarePayload",
        "kind": "LinkedField",
        "name": "ch_updateProgressNoteEpisodeOfCare",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v7/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": "updateProgressNoteEpisodeOfCareOutput",
            "args": null,
            "concreteType": "ch_UpdateProgressNoteEpisodeOfCareOutput",
            "kind": "LinkedField",
            "name": "ch_UpdateProgressNoteEpisodeOfCareOutput",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ch_ProgressNote",
                "kind": "LinkedField",
                "name": "progressNote",
                "plural": false,
                "selections": [
                  (v6/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "deleteEdge",
                    "key": "",
                    "kind": "ScalarHandle",
                    "name": "id",
                    "handleArgs": [
                      {
                        "kind": "Variable",
                        "name": "connections",
                        "variableName": "removedConnections"
                      }
                    ]
                  },
                  (v7/*:: as any*/),
                  (v6/*:: as any*/),
                  (v8/*:: as any*/),
                  (v9/*:: as any*/),
                  (v10/*:: as any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Appointment",
                    "kind": "LinkedField",
                    "name": "appointment",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v11/*:: as any*/),
                      (v12/*:: as any*/),
                      (v13/*:: as any*/),
                      (v14/*:: as any*/),
                      (v15/*:: as any*/),
                      (v16/*:: as any*/),
                      (v17/*:: as any*/),
                      (v18/*:: as any*/),
                      (v19/*:: as any*/),
                      (v20/*:: as any*/),
                      (v21/*:: as any*/),
                      (v22/*:: as any*/),
                      (v23/*:: as any*/),
                      (v24/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "QuestionnaireCriticalitySummaryOutput",
                        "kind": "LinkedField",
                        "name": "questionnaireCriticalitySummary",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "useCaseName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "criticals",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "warnings",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "infos",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "questionnaireType",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v25/*:: as any*/),
                      (v26/*:: as any*/),
                      (v27/*:: as any*/),
                      (v28/*:: as any*/),
                      (v29/*:: as any*/),
                      (v30/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ch_TelephoneLine",
                        "kind": "LinkedField",
                        "name": "telephoneLine",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ch_TelephoneLineTranslation",
                            "kind": "LinkedField",
                            "name": "telephoneLineTranslations",
                            "plural": true,
                            "selections": [
                              (v27/*:: as any*/),
                              (v31/*:: as any*/),
                              (v6/*:: as any*/)
                            ],
                            "storageKey": null
                          },
                          (v6/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AppointmentAttachment",
                        "kind": "LinkedField",
                        "name": "appointmentAttachments",
                        "plural": true,
                        "selections": [
                          (v6/*:: as any*/),
                          (v107/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "thumbnailUrl",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "uploadDate",
                            "storageKey": null
                          },
                          (v108/*:: as any*/),
                          (v109/*:: as any*/),
                          (v110/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "uploadSource",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v35/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BillingAttribute",
                        "kind": "LinkedField",
                        "name": "billingAttribute",
                        "plural": false,
                        "selections": [
                          (v6/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isNotBillable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "notBillableReason",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "treatmentReason",
                            "storageKey": null
                          },
                          (v19/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isVisualSymptomExamination",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "currentGestationWeek",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "organisationId",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "dateOfAccident",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "accidentReference",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isEmployer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lawType",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "ivgCaseReference",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mvgCaseReference",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "HealthOverview",
                        "kind": "LinkedField",
                        "name": "healthOverview",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "VitalSign",
                            "kind": "LinkedField",
                            "name": "vitalSign",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bloodPressureDiastolic",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bloodPressureSystolic",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bloodSugarMgDl",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bloodSugarMmol",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "bodyTemperature",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "breathRate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cReactiveProtein",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "glasgowComaScaleEye",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "glasgowComaScaleMotor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "glasgowComaScaleVerbal",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "heartRate",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "oxygenSaturation",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "strepATestPositive",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "visualAnalogPainScale",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "GeneralHealthInformation",
                            "kind": "LinkedField",
                            "name": "generalHealthInformation",
                            "plural": false,
                            "selections": [
                              (v83/*:: as any*/),
                              (v84/*:: as any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "medication",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "RequestedMedication",
                        "kind": "LinkedField",
                        "name": "requestedMedications",
                        "plural": true,
                        "selections": [
                          (v62/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "mainSubstance",
                            "storageKey": null
                          },
                          (v114/*:: as any*/),
                          (v112/*:: as any*/),
                          (v113/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v36/*:: as any*/),
                      (v39/*:: as any*/),
                      (v40/*:: as any*/),
                      (v41/*:: as any*/),
                      (v42/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Appointment",
                    "kind": "LinkedField",
                    "name": "followUpAppointment",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v43/*:: as any*/),
                      (v44/*:: as any*/),
                      (v45/*:: as any*/),
                      (v16/*:: as any*/),
                      (v20/*:: as any*/),
                      (v46/*:: as any*/),
                      (v50/*:: as any*/),
                      (v51/*:: as any*/),
                      (v52/*:: as any*/),
                      (v53/*:: as any*/),
                      (v54/*:: as any*/),
                      (v28/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FileUploadRequest",
                        "kind": "LinkedField",
                        "name": "fileUploadRequest",
                        "plural": false,
                        "selections": [
                          (v20/*:: as any*/),
                          (v55/*:: as any*/),
                          (v18/*:: as any*/),
                          (v6/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MedgateConnectOrder",
                        "kind": "LinkedField",
                        "name": "medgateConnectOrder",
                        "plural": false,
                        "selections": [
                          (v56/*:: as any*/),
                          (v20/*:: as any*/),
                          (v18/*:: as any*/),
                          (v6/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      (v42/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v57/*:: as any*/),
                  (v58/*:: as any*/),
                  (v59/*:: as any*/),
                  (v18/*:: as any*/),
                  (v60/*:: as any*/),
                  (v65/*:: as any*/),
                  (v68/*:: as any*/),
                  (v69/*:: as any*/),
                  {
                    "alias": "sickLeave",
                    "args": null,
                    "concreteType": "ch_SickLeave",
                    "kind": "LinkedField",
                    "name": "ch_sickLeave",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v71/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v66/*:: as any*/),
                      (v67/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      (v27/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "certificateType",
                        "storageKey": null
                      },
                      (v19/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "workCapacity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "workCapacityType",
                        "storageKey": null
                      },
                      (v120/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "followUpId",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "generalAttestation",
                    "args": null,
                    "concreteType": "ch_GeneralAttestation",
                    "kind": "LinkedField",
                    "name": "ch_generalAttestation",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v73/*:: as any*/),
                      (v72/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v62/*:: as any*/),
                      (v79/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      (v27/*:: as any*/),
                      (v4/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "attestationGuardian",
                    "args": null,
                    "concreteType": "ch_AttestationGuardian",
                    "kind": "LinkedField",
                    "name": "ch_attestationGuardian",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v80/*:: as any*/),
                      (v81/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      (v27/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "certificate",
                        "storageKey": null
                      },
                      (v47/*:: as any*/),
                      (v48/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "birthDate",
                        "storageKey": null
                      },
                      (v121/*:: as any*/),
                      (v120/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "psychologicalPsychotherapy",
                    "args": null,
                    "concreteType": "ch_PsychotherapyPrescription",
                    "kind": "LinkedField",
                    "name": "ch_psychotherapyPrescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v82/*:: as any*/),
                      (v37/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      (v99/*:: as any*/),
                      (v120/*:: as any*/),
                      (v27/*:: as any*/),
                      (v19/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "therapyPrescription",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "physiotherapy",
                    "args": null,
                    "concreteType": "ch_PhysiotherapyPrescription",
                    "kind": "LinkedField",
                    "name": "ch_physiotherapyPrescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v82/*:: as any*/),
                      (v37/*:: as any*/),
                      (v83/*:: as any*/),
                      (v84/*:: as any*/),
                      (v85/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      (v99/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "aims",
                        "storageKey": null
                      },
                      (v86/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "conditionStage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "duration",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "internalNote",
                        "storageKey": null
                      },
                      (v27/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "leadingSymptom",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "prescriptionRepetition",
                        "storageKey": null
                      },
                      (v19/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sides",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "trigger",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "treatmentUnitPerDay",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isHomeTreatment",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "occurrence",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_NutritionalPrescription",
                    "kind": "LinkedField",
                    "name": "ch_nutritionalPrescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v8/*:: as any*/),
                      (v82/*:: as any*/),
                      (v37/*:: as any*/),
                      (v86/*:: as any*/),
                      (v27/*:: as any*/),
                      (v70/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      (v120/*:: as any*/),
                      (v19/*:: as any*/),
                      (v84/*:: as any*/),
                      (v83/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "nutritionalConditions",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "obesityTherapy",
                        "storageKey": null
                      },
                      (v85/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "prescription",
                    "args": null,
                    "concreteType": "ch_Prescription",
                    "kind": "LinkedField",
                    "name": "ch_prescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v82/*:: as any*/),
                      (v92/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      (v27/*:: as any*/),
                      (v99/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "measLaboratoryPrescription",
                    "args": null,
                    "concreteType": "ch_MeasLaboratoryPrescription",
                    "kind": "LinkedField",
                    "name": "ch_measLaboratoryPrescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      (v27/*:: as any*/),
                      (v99/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "bloodChemistries",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "coagulations",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hematologies",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "urineDiagnostics",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rapidTests",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "referralLetter",
                    "args": null,
                    "concreteType": "ch_ReferralLetter",
                    "kind": "LinkedField",
                    "name": "ch_referralLetter",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v78/*:: as any*/),
                      (v99/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "reasoning",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "referralId",
                        "storageKey": null
                      },
                      (v86/*:: as any*/),
                      (v83/*:: as any*/),
                      (v84/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "documentLanguage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "careProviderIds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CareProvider",
                        "kind": "LinkedField",
                        "name": "careProvidersCopyTo",
                        "plural": true,
                        "selections": [
                          (v6/*:: as any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "IcdDiagnosis",
                        "kind": "LinkedField",
                        "name": "icdDiagnosis",
                        "plural": false,
                        "selections": [
                          (v6/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isAssociation",
                            "storageKey": null
                          },
                          (v37/*:: as any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "primaryCode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "secondaryCode",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "associationType",
                            "storageKey": null
                          },
                          (v38/*:: as any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_ConsultationReport",
                    "kind": "LinkedField",
                    "name": "ch_consultationReport",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v27/*:: as any*/),
                      (v82/*:: as any*/),
                      (v37/*:: as any*/),
                      (v69/*:: as any*/),
                      (v93/*:: as any*/),
                      (v78/*:: as any*/),
                      (v99/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAiGenerated",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isAiContentModified",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "carePlanSummary",
                    "args": null,
                    "concreteType": "Ch_carePlanSummaryConnection",
                    "kind": "LinkedField",
                    "name": "ch_carePlanSummary",
                    "plural": false,
                    "selections": (v96/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "carePlanSummary",
                    "args": null,
                    "filters": null,
                    "handle": "connection",
                    "key": "ProgressNoteConnection_carePlanSummary",
                    "kind": "LinkedHandle",
                    "name": "ch_carePlanSummary"
                  },
                  {
                    "alias": "timeWindows",
                    "args": null,
                    "concreteType": "Ch_timeWindowsConnection",
                    "kind": "LinkedField",
                    "name": "ch_timeWindows",
                    "plural": false,
                    "selections": (v97/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": "timeWindows",
                    "args": null,
                    "filters": null,
                    "handle": "connection",
                    "key": "ChProgressNoteConnection_ch_timeWindows",
                    "kind": "LinkedHandle",
                    "name": "ch_timeWindows"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_MeasRadiologyPrescription",
                    "kind": "LinkedField",
                    "name": "ch_measRadiologyPrescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v70/*:: as any*/),
                      (v8/*:: as any*/),
                      (v72/*:: as any*/),
                      (v73/*:: as any*/),
                      (v59/*:: as any*/),
                      (v18/*:: as any*/),
                      (v58/*:: as any*/),
                      (v57/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v98/*:: as any*/),
                      (v78/*:: as any*/),
                      (v99/*:: as any*/),
                      (v27/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clinicalAssessment",
                        "storageKey": null
                      },
                      (v121/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pregnantStatus",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "question",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_NeuropsychologicDiagnosticPrescription",
                    "kind": "LinkedField",
                    "name": "ch_neuropsychologicDiagnosticPrescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v99/*:: as any*/),
                      (v8/*:: as any*/),
                      (v18/*:: as any*/),
                      (v57/*:: as any*/),
                      (v73/*:: as any*/),
                      (v72/*:: as any*/),
                      (v27/*:: as any*/),
                      (v59/*:: as any*/),
                      (v58/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v70/*:: as any*/),
                      (v78/*:: as any*/),
                      (v100/*:: as any*/),
                      (v101/*:: as any*/),
                      (v62/*:: as any*/),
                      (v64/*:: as any*/),
                      (v102/*:: as any*/),
                      (v82/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ch_LaboratoryPrescription",
                    "kind": "LinkedField",
                    "name": "ch_laboratoryPrescription",
                    "plural": false,
                    "selections": [
                      (v6/*:: as any*/),
                      (v99/*:: as any*/),
                      (v8/*:: as any*/),
                      (v18/*:: as any*/),
                      (v57/*:: as any*/),
                      (v73/*:: as any*/),
                      (v72/*:: as any*/),
                      (v27/*:: as any*/),
                      (v103/*:: as any*/),
                      (v104/*:: as any*/),
                      (v105/*:: as any*/),
                      (v106/*:: as any*/),
                      (v59/*:: as any*/),
                      (v58/*:: as any*/),
                      (v74/*:: as any*/),
                      (v75/*:: as any*/),
                      (v76/*:: as any*/),
                      (v77/*:: as any*/),
                      (v70/*:: as any*/),
                      (v78/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MedicalReportAttachmentConnection",
                    "kind": "LinkedField",
                    "name": "medicalReportAttachments",
                    "plural": false,
                    "selections": (v111/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "connection",
                    "key": "ProgressNoteConnection_medicalReportAttachments",
                    "kind": "LinkedHandle",
                    "name": "medicalReportAttachments"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Ch_recommendedMedicationsConnection",
                    "kind": "LinkedField",
                    "name": "ch_recommendedMedications",
                    "plural": false,
                    "selections": (v115/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "connection",
                    "key": "ProgressNoteConnection_ch_recommendedMedications",
                    "kind": "LinkedHandle",
                    "name": "ch_recommendedMedications"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Ch_callTranscriptsConnection",
                    "kind": "LinkedField",
                    "name": "ch_callTranscripts",
                    "plural": false,
                    "selections": (v116/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "filters": null,
                    "handle": "connection",
                    "key": "ProgressNoteConnection_ch_callTranscripts",
                    "kind": "LinkedHandle",
                    "name": "ch_callTranscripts"
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "filters": null,
                "handle": "prependNode",
                "key": "",
                "kind": "LinkedHandle",
                "name": "progressNote",
                "handleArgs": [
                  {
                    "kind": "Variable",
                    "name": "connections",
                    "variableName": "addConnections"
                  },
                  {
                    "kind": "Literal",
                    "name": "edgeTypeName",
                    "value": "ch_ProgressNoteEdge"
                  }
                ]
              },
              (v118/*:: as any*/),
              (v119/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "a6c8e6077212cfff30e6e8d98674323b",
    "metadata": {},
    "name": "chUpdateProgressNoteEpisodeOfCareMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "1329f8d436366091b49995ad61511b41";

export default node;
